import React from 'react';
import { $Button } from './styles';
export const Button = ({ children, ...rest }) => React.createElement($Button, { variant: 'contained', ...rest }, children);
